<template>
  <div class="app-container">
    <!-- 主要内容区域 -->
    <el-dialog
      title="学生作品"
      :visible="localDialogTableVisible"
      @close="handleDialogClose"
      width="720px"
      class="works-detail-dialog"
    >
      <div class="img">
        <el-button
          class="button"
          icon="el-icon-arrow-left"
          @click="imgchange('up')"
        ></el-button>
        <el-image
          class="preview-image"
          :src="workDetail.pictureUrl || url"
          :preview-src-list="[workDetail.pictureUrl || url]"
          fit="cover"
        >
        </el-image>
        <el-button
          class="button"
          icon="el-icon-arrow-right"
          @click="imgchange('down')"
        ></el-button>
      </div>
      <div class="imglist">
        <img
          :src="item"
          :class="active == i ? 'active' : ''"
          alt=""
          v-for="(item, i) in srcList"
          :key="i"
          @click="handleimg(i)"
        />
      </div>
      <div class="info">
        <div class="student">学员：{{ workDetail.studentName || '数据加载中...' }}</div>
        <div>所属班级：{{ workDetail.className || '数据加载中...' }}</div>
        <div>上传时间：{{ formatDate(workDetail.createTime) }}</div>
        <div>作品类型：{{ getWorksTypeName(workDetail.worksType) }}</div>
        <div>作品标题：{{ workDetail.title || '数据加载中...' }}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getwork } from "@/api/index.js";
export default {
  name: "production",
  components: {},
  props: {
    id: {
      type: [String, Number],
      required: false,
    },
    dialogTableVisible: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      url:
        "https://web-1322480718.cos.ap-nanjing.myqcloud.com/20230529/20230529161522_ft4y.jpeg?imageMogr2/format/webp",
      srcList: [
        "https://web-1322480718.cos.ap-nanjing.myqcloud.com/20230529/20230529161522_ft4y.jpeg?imageMogr2/format/webp",
        "http://web-1322480718.cos.ap-nanjing.myqcloud.com/20230529/20230529161527_r9vh.jpeg?imageMogr2/format/webp",
      ],
      workDetail: {
        studentName: '',
        className: '',
        title: '',
        worksType: 1,
        createTime: '',
        pictureUrl: '',
        content: ''
      }, // 作品详情数据
      active: 0,
      localDialogTableVisible: this.dialogTableVisible,
    };
  },
  watch: {
    dialogTableVisible(newVal) {
      this.localDialogTableVisible = newVal;
      if (newVal && this.id) {
        // 重置数据
        this.workDetail = {
          studentName: '',
          className: '',
          title: '',
          worksType: 1,
          createTime: '',
          pictureUrl: '',
          content: ''
        };
        this.getwork();
      }
    },
    id(newVal) {
      if (newVal && this.localDialogTableVisible) {
        this.getwork();
      }
    }
  },
  methods: {
    handleDialogClose() {
      this.$emit("update:dialogTableVisible", false);
    },
    getwork() {
      if (!this.id) return;
      
      console.log('获取作品详情，ID:', this.id);
      
      getwork({ id: this.id }).then((res) => {
        console.log('作品详情API响应:', res);
        
        // 标准的后端API响应格式：{ code: 200, data: {...}, msg: "成功" }
        if (res.code === 200 && res.data) {
          this.workDetail = res.data;
          console.log('设置作品详情:', this.workDetail);
        } else if (res.code === 0 && res.data) {
          // 兼容code为0的情况
          this.workDetail = res.data;
          console.log('设置作品详情(code=0):', this.workDetail);
        } else if (res.data && !res.code) {
          // 如果没有code字段，直接使用data
          this.workDetail = res.data;
          console.log('设置作品详情(无code):', this.workDetail);
        } else {
          console.error('作品详情数据格式错误:', res);
          // 设置默认数据避免显示"未知"
          this.workDetail = {
            studentName: '暂无数据',
            className: '暂无数据',
            title: '暂无数据',
            worksType: 1,
            createTime: new Date().toISOString(),
            pictureUrl: this.url
          };
        }
      }).catch(error => {
        console.error('获取作品详情失败:', error);
        // 设置默认数据
        this.workDetail = {
          studentName: '获取失败',
          className: '获取失败', 
          title: '获取失败',
          worksType: 1,
          createTime: new Date().toISOString(),
          pictureUrl: this.url
        };
      });
    },
    imgchange(type) {
      // 简化图片切换逻辑，目前只有一张图片
      // 如果后续需要支持多图片，可以扩展这里的逻辑
      const currentIndex = this.srcList.indexOf(this.url);
      let newIndex;
      if (type === "up") {
        newIndex = currentIndex === 0 ? this.srcList.length - 1 : currentIndex - 1;
      } else if (type === "down") {
        newIndex = currentIndex === this.srcList.length - 1 ? 0 : currentIndex + 1;
      }
      this.url = this.srcList[newIndex];
      this.active = newIndex;
    },
    handleimg(index) {
      // 简化图片选择逻辑
      this.url = this.srcList[index];
      this.active = index;
    },
    formatDate(dateString) {
      if (!dateString) return '未知';
      try {
        const date = new Date(dateString);
        return date.toLocaleString('zh-CN');
      } catch (error) {
        return dateString;
      }
    },
    getWorksTypeName(worksType) {
      const typeMap = {
        1: '平面设计',
        2: '插画设计'
      };
      return typeMap[worksType] || '未知类型';
    }
  },
};
</script>

<style scoped lang="scss">
.app-container {
  padding: 0;
  margin: 0;
  font-family: "Microsoft YaHei";
  color: #333;
  overflow: hidden;
  clear: both;
  text-align: left;

  .img {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;

    .preview-image {
      width: 530px;
      height: 358px;
      max-width: 100%;
    }

    .button {
      width: 32px;
      height: 98px;
      background-color: #f5f6f9;
      font-size: 30px;
      margin: 0 20px;
      padding: 0;
      border: none;
    }
  }
  .imglist {
    display: flex;
    align-items: center;
    margin: 20px 75px;
    img {
      width: 120px;
      height: 84px;
      margin-right: 20px;
      object-fit: cover;
      cursor: pointer;
    }
    .active {
      border: 2px solid red; // 添加红色边框
    }
  }
  .info {
    margin: 0 70px;
    .student {
      font-size: 18px;
      font-weight: bold;
    }
    div {
      font-size: 16px;
      color: #2d3341;
      margin-bottom: 15px;
    }
  }
}

@media (max-width: 768px) {
  :deep(.works-detail-dialog) {
    width: 94% !important;
    margin: 0 auto !important;
  }

  .app-container {
    .img {
      .button {
        display: none;
      }

      .preview-image {
        width: 100%;
        height: auto;
        min-height: 180px;
        max-height: 60vh;
      }
    }

    .imglist {
      margin: 12px 0;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;

      img {
        width: 88px;
        height: 62px;
        margin-right: 10px;
        flex-shrink: 0;
      }
    }

    .info {
      margin: 0;
      font-size: 14px;

      .student {
        font-size: 16px;
      }

      div {
        font-size: 14px;
        margin-bottom: 10px;
      }
    }
  }
}
</style>